import React from 'react'
import { Link } from 'react-router-dom'

export default () => (
    <div className="dashboardLinkWrapper">
        <Link to="/admin/reports">
            <div className="dashboardLink">
                <div className="dashboardLinkHeaderText is-size-4">
                    Reporting Menu
                </div>
            </div>
        </Link>
    </div>
)
